import * as S from './PropertyVideo.styled'
import { Detail, DetailHeading } from '../PropertyDetails.styled'
import Video from '@global/Video'
import { getYoutubeThumbnail } from '@lib/helpers'

const PropertyVideo = ({ videos }) => {

  return (
    <Detail>
      <DetailHeading>Property Video</DetailHeading>
      {videos
        .filter(href => href.link_type === 'video')
        .map((video, index) => (
          <S.VideoWrap>
            <Video
              key={index}
              videoUrl={video.href}
              videoThumbnail={getYoutubeThumbnail(video.href)}
              border
              borderAll
            />
          </S.VideoWrap>
      ))}
    </Detail>
  )
}

export default PropertyVideo
